<template>
  <div class="videoList-box" v-loading="exportLoading" element-loading-text="导出中..."
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div></div>
    <div style="margin-bottom: 15px">
      <el-button type="primary" size="small">一键生成非用户视频点赞和评论</el-button>
      <!-- TODO 以后添加的功能
      <el-input placeher="抽税" size="small" class="param-input" style="margin-left: 100px;"></el-input>
      <el-button type="primary" size="small">修改</el-button>
      -->
    </div>
    <!--操作栏-->
    <div class="action-bar">
      审核状态:
      <el-select v-model="params.status" placeholder="审核状态" size="small" @change="getVideoList('status')">
        <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>帖子精选:
      <el-select v-model="params.chosen" placeholder size="small" @change="getVideoList('status')">
        <el-option v-for="item in chosen" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>帖子类型:
      <el-select v-model.number="params.newsType" placeholder="帖子类型" size="small" @change="getVideoList('status')"
        clearable>
        <el-option label="全部" :value="0"></el-option>
        <el-option label="长视频" :value="5"></el-option>
        <el-option label="短视频" :value="6"></el-option>
        <el-option label="图集" :value="2"></el-option>
        <el-option label="种子贴子" :value="7"></el-option>
        <el-option label="黄游帖子" :value="8"></el-option>
        <el-option label="视频广告" :value="3"></el-option>
        <el-option label="图片广告" :value="4"></el-option> </el-select>
      是否为用户:
      <el-select v-model="params.isUserUp" placeholder="是否为用户" size="small" @change="getVideoList('status')">
        <el-option v-for="item in isUserUp" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      视频权益:
      <el-select v-model="params.permission" placeholder="选择视频权益" size="small" clearable
        @change="getVideoList('status')">
        <el-option v-for="item in videoPermissionTypes" :key="item.value" :label="item.label"
          :value="item.value"></el-option> </el-select>是否推荐
      <el-select v-model="params.isRecommended" placeholder="是否推荐" clearable size="small"
        @change="getVideoList('status')">
        <el-option v-for="item in isRecommended" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      是否强推
      <el-select v-model="params.isPush" placeholder="是否强推" clearable size="small" @change="getVideoList('status')">
        <el-option v-for="item in isPushing" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select><br>
      是否置顶:
      <el-select v-model="params.isTop" placeholder="是否置顶" size="small" @change="getVideoList('status')">
        <el-option v-for="item in isLiaoBaTop" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      是否幸福广场置顶:
      <el-select v-model="params.isHappinessPlazaTop" placeholder="是否幸福广场置顶" size="small"
        @change="getVideoList('status')">
        <el-option v-for="item in happinessPlazaTops" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>

      是否设置专题排序码:
      <el-select v-model="params.isSortedUnderModule" placeholder="是否设置专题排序码" size="small"
        @change="getVideoList('status')">
        <el-option v-for="item in sortedUnderModule" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      是否社区帖子:
      <el-select v-model="params.isCommunity" placeholder="是否社区帖子" size="small" @change="getVideoList('status')">
        <el-option v-for="item in sortedUnderModule" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      是否短视频展示:
      <el-select v-model="params.isTiktok" placeholder="是否短视频展示" size="small" @change="getVideoList('status')">
        <el-option v-for="item in sortedUnderModule" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select><br>
      <el-input v-model="params.tag" placeholder="请输入标签名" clearable @keyup.enter.native="getVideoList('status')"
        size="small" class="param-input"></el-input>
      <el-input v-model="searchUid" placeholder="请输入用户ID" clearable @keyup.enter.native="getVideoList('status')"
        size="small" class="param-input" @change="changeUid"></el-input>

      <el-input v-model="params.title" placeholder="请输入帖子标题" clearable @keyup.enter.native="getVideoList('status')"
        size="small" class="param-input"></el-input>

      <el-input v-model="params.id" placeholder="请输入帖子ID" clearable @keyup.enter.native="getVideoList('status')"
        size="small" class="param-input"></el-input>

      <el-select v-model="searchSubSections" placeholder="请选择父专题" size="small" clearable @change="searchSelectSection">
        <el-option v-for="(section, index) in sections" :key="index" :label="section.moduleName" :value="section.id">
        </el-option>
      </el-select>

      <el-select v-model="params.sectionID" placeholder="请选择子专题" size="small" clearable>
        <el-option v-for="(subSection, index) in subTopicOptions" :key="index" :label="subSection.sectionName"
          :value="subSection.id">
        </el-option>
      </el-select>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" size="small" @change="changeTime"></el-date-picker>
      <el-button type="primary" size="small" @click="getVideoList('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="exportdata">导出</el-button>
      <el-button type="success" size="small" @click="openSelection('setTopic')" :disabled="isDisabled">选择专题</el-button>
      <el-button style="background-color:#ed6ea0;color:white" size="small" @click="openSelection('featured')"
        :disabled="isDisabled">批量是否为精选</el-button>
      <el-button type="primary" size="small" @click="batchDelete('delete')" :disabled="isDisabled">批量删除</el-button>
      <el-button type="warning" size="small" @click="openSelection('recommend')"
        :disabled="isDisabled">批量设置是否推荐</el-button>
      <el-button type="warning" size="small" @click="openSetPopularity()" :disabled="isDisabled">配置视频热度统计方式</el-button>
      <el-button type="success" size="small" @click="openHotQuery()" :disabled="isDisabled">视频热度查询</el-button>
      <el-button type="danger" size="small" @click="openSelection('setFree')"
        :disabled="isDisabled">批量设置标签/观看权限</el-button>
      <el-button type="success" size="small" @click="openSelection('setRemoved')"
        :disabled="isDisabled">批量下架</el-button>
      <el-button type="success" size="small" @click="openSelection('setPublisher')"
        :disabled="isDisabled">批量设置发布者</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border ref="multipleTable" v-loading="loading"
      element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @sort-change="handleSortChange"
      height="580" @selection-change="handleSelectionChange">
      <el-table-column type="selection" v-if="isSelection" width="55" fixed="left" align="center">
      </el-table-column>
      <el-table-column prop="id" label="帖子ID" align="center" width="220"></el-table-column>
      <el-table-column prop="activityId" label="活动ID" align="center" width="220">
        <template slot-scope="scope">
          <el-tag v-if="
            scope.row.activityId == '000000000000000000000000' ||
            !scope.row.activityId
          ">不参加活动</el-tag>
          <span v-else>{{ scope.row.activityId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortCodeUnderSection" label="专题排序" align="center" width="80"></el-table-column>
      <el-table-column prop="happinessPlazaTop" label="幸福广场排序" align="center" width="80"></el-table-column>
      <el-table-column prop="recoWeight" label="精选排序值" align="center" width="80"></el-table-column>
      <el-table-column prop="isCommunity" label="是否社区帖子" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isCommunity">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isTiktok" label="是否短视频展示" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isTiktok">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="newsType" label="帖子类型" align="center" width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{
            scope.row.newsType | getNewsTypeName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户ID" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="UP主ID" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.vlogger_user_id || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核结果" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 1">审核通过</span>
          <span v-if="scope.row.status === 2">未通过</span>
          <!-- <span v-if="scope.row.status === 3 ">视为免费</span> -->
          <!-- <span v-if="scope.row.status === 4 ">免审认证</span> -->
          <span v-if="scope.row.status === 5">下架</span>
        </template>
      </el-table-column>
      <el-table-column prop="resolution" label="清晰度" align="center" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.resolution || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="视频标题" align="center" :show-overflow-tooltip="true" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.title || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="视频内容" align="center" width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.content || "-" }}</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="isFree" label="是否免费" align="center" width="100">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isFree" disabled size="small"></el-switch>
        </template>
      </el-table-column>
      -->
      <el-table-column label="封面图" align="center" width="80">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="tags" label="父专题" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.moduleName || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="tags" label="子专题" align="center" width="150">
        <template slot-scope="scope">
          {{ scope.row.sectionName || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="sourceURL" label="预览视频" align="center" width="80">
        <template slot-scope="scope" v-if="scope.row.sourceURL">
          <i class="el-icon-video-play" style="font-size: 20px; color: #ed6ea0;" title="点击预览" @click="checkMedia(scope.row.sourceURL, 'video')"></i>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="视频权限" align="center" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.permission | getVideoPermissionName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="用户昵称" align="center" width="80" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.publisher.name || "未知" }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="coins" label="价格" align="center" width="80" :sortable="'custom'"></el-table-column>
      <el-table-column prop="playCount" label="播放数(真)" align="center" width="80" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.playCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="likeCount" label="点赞数(真)" align="center" width="80" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.likeCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="likeRate" label="点赞率(真)" align="center" width="80" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.likeRate | transformFloat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="purchaseRate" label="成交率" align="center" width="80" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.purchaseRate || 0) | transformFloat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalSellDays" label="售卖天数(总)" align="center" width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.totalSellDays || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalSellCount" label="售卖次数(总)" align="center" width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.totalSellCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalSellAmount" label="售卖金币(总)" align="center" width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.totalSellAmount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="hitRate" label="点击率(真)" align="center" width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.hitRate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="pageViewCount" label="展现量(总)" align="center" width="100" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.pageViewCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="playTime" label="总时长" align="center" width="130" :sortable="'custom'">
        <template slot-scope="scope">{{
          scope.row.playTime | changeSecond
        }}</template>
      </el-table-column>
      <el-table-column label="是否为精选" align="center" width="80">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.chosen" @change="setChosen(scope.row, 'chosen')"></el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column label="是否撩吧置顶" align="center" width="80">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.liaoBaTop" @change="setChosen(scope.row, 'liaoBaTop')"></el-switch>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="是否幸福广场置顶" align="center" width="80">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.happinessPlazaTop" @change="setChosen(scope.row, 'happinessPlazaTop')"></el-switch>
        </template>
      </el-table-column> -->
      <el-table-column prop="seriesCover" label="图集预览" align="center" width="100">
        <template slot-scope="scope">
          <!-- <span v-if="!scope.row.seriesCover || !scope.row.seriesCover.length">未知</span> -->
          <el-button v-if="!scope.row.seriesCover || !scope.row.seriesCover.length" type="success" size="mini"
            icon="el-icon-edit" @click="
              previewPicture(
                scope.row.seriesCover || [],
                scope.row.id,
                scope.row.tags
              )
              "></el-button>
          <div v-else class="picturePreview" @click="
            previewPicture(
              scope.row.seriesCover,
              scope.row.id,
              scope.row.tags
            )
            ">
            <decrypt-img style="width: 50px; height: 50px" :src="imgUrl + item" :iPreviewSrcList="[]" fit="fill"
              v-for="(item, i) in scope.row.seriesCover" :key="i"></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="url" label="原视频下载" align="center" width="100">
        <template slot-scope="scope" v-if="scope.row.newsType === 'SP' || scope.row.newsType === 'MOVIE'">
          <el-button type="success" size="small" @click="downloadMedia(scope.row)">
            <i class="el-icon-download" title="原视频下载"></i>
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="size" label="帖子大小(M)" align="center" width="100">
        <template slot-scope="scope">
          <span>{{ (scope.row.size / 1024 / 1024) | transformFloat }}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否为用户" align="center" width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.isUser ? "是" : "否" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="是否为免费专区" align="center" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.freeArea" @change="setChosen(scope.row, 'free')"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="是否置顶" align="center" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isTopping" @change="setChosen(scope.row, 'isTopping')"></el-switch>
        </template>
      </el-table-column>

      <el-table-column label="是否力荐" align="center" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isRecommend" @change="setChosen(scope.row, 'isRecommend')"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="是否置精" align="center" width="120">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isChoosen" @change="setChosen(scope.row, 'isChoosen')"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="freeTime" label="免费时长" align="center" width="130" :sortable="'custom'">
        <template slot-scope="scope">{{
          scope.row.freeTime | changeSecond
        }}</template>
      </el-table-column>
      <el-table-column prop="freeTime" label="有效播放率" align="center" width="120">
        <template slot-scope>
          <span>功能未添加</span>
        </template>
      </el-table-column>

      <el-table-column prop="fakePlayCount" label="播放数(假)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.fakePlayCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="fakeLikeCount" label="点赞数(假)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.fakeLikeCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="fakeShareCount" label="分享数(假)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.fakeShareCount || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="commentCount" label="评论数(真)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.commentCount || "0") | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rewarded" label="打赏金额" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.rewarded || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fakeRewarded" label="打赏金额(假)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ (scope.row.fakeRewarded || 0) | numFormat }}</span>
        </template>
      </el-table-column>
      <!-- 评论数为真是数据
      <el-table-column prop="fakeCommentCount" label="评论数(假)" align="center" width="140" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{(scope.row.fakeCommentCount || 0) | numFormat}}</span>
        </template>
      </el-table-column>
      -->
      <el-table-column prop="tags" label="标签" align="center" min-width="200">
        <template slot-scope="scope">
          <div v-for="(tag, i) in scope.row.tags" :key="i" class="tagBox">
            <el-tag type="success" size="mini" effect="plain" class="tags">{{
              "#" + tag.name
            }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="shareSort" label="分享排序值" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.shareSort || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="更新时间" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="上传时间" align="center" width="160" :sortable="'custom'">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="审核失败原因" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.reason || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="reviewAccount" label="审核人" align="center" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.reviewAccount }}</span>
        </template>
      </el-table-column>
      <el-table-column label="富文本" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-edit" @click="editRichText(scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="sortVideo(scope.row)">排序</el-button>
          <el-button type="success" size="mini" @click="openComment(scope.row)">评论</el-button>
          <el-button v-if="scope.row.pushing" type="success" size="mini"
            @click="quxiaoQtVideo(scope.row.id)">取消强推</el-button>
          <el-button v-if="!scope.row.pushing" type="success" size="mini" @click="forcePush(scope.row)">强推</el-button>
          <el-button type="success" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <!--
          <el-tooltip content="置顶" placement="top">
            <el-button type="warning" size="mini" icon="el-icon-upload2" @click="placement(scope.row)"></el-button>
          </el-tooltip>
          -->
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeVideo(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
    <!--视频编辑弹窗-->
    <edit-video ref="editVideo" @handlerVideoList="handlerVideoList"></edit-video>
    <!--视频热度查询-->
    <vid-hotQuery ref="hotQuery"></vid-hotQuery>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture" @handlerPreviewList="handlerPreviewList"></preview-picture>
    <!-- 设置视频热度统计方式 -->
    <set-Popularity ref="setPopularity" />
    <!-- 分页组件 -->
    <div class="bottom">
      <div class="btn" v-if="isSelection">
        <el-button type="info" size="mini" @click="giveUp">放弃操作</el-button>
        <el-button type="primary" size="mini" @click="subSection">提交</el-button>
      </div>
      <div class="page">
        <el-pagination :page-sizes="[10, 25, 50, 100]" :current-page="params.pageNumber" :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10"
          @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
      </div>
    </div>
    <comment-action ref="commentAction" @handleList="getVideoList('status')" />
    <!-- TODO：待添加 编辑主题弹窗 -->
    <dialog-change-topic :visible="dialogVisible" :sections="sections" @close="close"
      @sure="uploadSection"></dialog-change-topic>
    <el-dialog title="批量操作精选视频" :visible.sync="isFeatured" width="400px">
      <el-form ref="form" label-width="100px">
        <el-form-item label="更改精选">
          <el-select v-model="featured" placeholder="请选择是否为精选" size="small" clearable>
            <el-option v-for="(item, index) in featureds" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">取 消</el-button>
        <el-button type="primary" @click="uploadSection" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量修改是否推荐" :visible.sync="isRecommendSta" width="400px" @close="closeRecommend">
      <el-form ref="form" label-width="100px">
        <el-form-item label="更改是否推荐">
          <el-select v-model="batchRecommend" placeholder="请选择是否为推荐" size="small" clearable>
            <el-option v-for="(item, index) in isRecommended" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="isRecommendSta = false">取 消</el-button>
        <el-button type="primary" @click="batchSetRecommend" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量删除" :visible.sync="isBatchDelete" width="1300px">
      <el-table :data="videoIds" highlight-current-row border class="batchdelete">
        <el-table-column prop="id" label="帖子ID" align="center" width="220" fixed="left"></el-table-column>
        <el-table-column prop="newsType" label="帖子类型" align="center" width="140" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{
              scope.row.newsType | getNewsTypeName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.publisher.uid || "未知" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核结果" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">审核通过</span>
            <span v-if="scope.row.status === 2">未通过</span>
            <span v-if="scope.row.status === 5">下架</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="视频标题" align="center" :show-overflow-tooltip="true" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.title || "未知" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="封面图" align="center" width="140">
          <template slot-scope="scope">
            <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="审核失败原因" align="center" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.reason || "未知" }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelBatechDel">取 消</el-button>
        <el-button type="primary" @click="confirmBatechDel" :loading="isBatchDeleteLoading">确 定</el-button>
      </span>
    </el-dialog>
    <!--批量标签话题编辑弹窗-->
    <batch-tags-popup ref="batchTagsPopup" @handlerClose="handlerClose"></batch-tags-popup>
    <el-dialog title="批量修改是否免费" :visible.sync="isSetFree" width="400px" @close="closeIsSetFree">
      <el-form ref="form" label-width="100px">
        <el-form-item label="是否免费">
          <el-select v-model="setFreeArea" placeholder="请选择是否免费" size="small" clearable>
            <el-option v-for="(item, index) in isBatchFree" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="isSetFree = false">取 消</el-button>
        <el-button type="primary" @click="batchSetFree()" size="small">确 定</el-button>
      </span>
    </el-dialog>
    <DialogChangeTags ref="changeTagsRef" :visible.sync="isSetFree" @submit="batchPermission"></DialogChangeTags>
    <DialogSetPublishers ref="setPublishersRef" :visible.sync="isSetPublishers" @close="giveUp"
      @submit="batchSetPublushers"></DialogSetPublishers>
    <RichEditor ref="editor" @handlerLoadList="getVideoList"></RichEditor>
  </div>
</template>

<script>
// import { paramsFilter } from '@/utils/global'
import MediaPopup from "@/components/media-popup";
import RichEditor from "@/components/rich-editor";
import EditVideo from "./components/edit-video";
import DialogChangeTopic from './components/dialog-change-topic';
import baseConfig from "@/utils/serverUrlConfig";
import { sortEscape, changeTime } from "@/utils/global";
import PreviewPicture from "./components/previewPicture";
import CommentAction from "@/components/commentAction";
import SetPopularity from "./components/setPopularity";
import VidHotQuery from "./components/vidHotQuery";
import BatchTagsPopup from "@/components/batchTagsPopup";
import DialogChangeTags from "./components/dialog-change-tags.vue";
import DialogSetRemoved from "./components/dialog-set-removed.vue";
import DialogSetPublishers from "./components/dialog-set-publishers.vue";
import API from "@/api";
import { getTypeLabel, videoPermissionTypes } from "../../../config";

export default {
  data() {
    return {
      isBatchEditing: false,
      isSetRemoved: false,
      isSetPublishers: false,
      // 是否添加推送
      // 状态
      status: [
        {
          label: "通过",
          value: 1,
        },
        {
          label: "未通过",
          value: 2,
        },
        {
          label: "视为免费",
          value: 3,
        },
        {
          label: "全部状态",
          value: 5,
        },
      ],
      searchUid: "",
      studioId: "",
      studioList: [],
      // 是否付费
      chosen: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "精选",
          value: 1,
        },
        {
          label: "非精选",
          value: 2,
        },
      ],
      // 是否精选
      featured: true,
      featureds: [
        {
          label: "精选",
          value: true,
        },
        {
          label: "非精选",
          value: false,
        },
      ],
      // 是否为免费专区
      free: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 2,
        },
      ],
      // 是否为用户
      isUserUp: [
        {
          label: "全部",
          value: 2,
        },
        {
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      // 视频权限
      videoPermissionTypes,
      // 是否免费
      isBatchFree: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      // 是否推荐
      isRecommended: [
        {
          label: "推荐",
          value: true,
        },
        {
          label: "不推荐",
          value: false,
        },
      ],
      // 是否强推
      isPushing: [
        {
          label: "全部",
          value: false,
        },
        {
          label: "强推",
          value: true,
        },
      ],
      // 是否设置专题排序码
      sortedUnderModule: [
        {
          label: "全部",
          value: undefined,
        },
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      // 是否撩吧置顶
      isLiaoBaTop: [
        {
          label: "全部",
          value: undefined,
        },
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      happinessPlazaTops: [
        {
          label: "全部",
          value: undefined,
        },
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      imgUrl: baseConfig.imgUrl,
      loading: false,
      // 列表数据
      tableData: [],
      total: "",
      time: "",
      // 请求列表查询
      params: {
        pageNumber: 1,
        pageSize: 10,
        permission: null,
        key: "",
        value: "",
        start: "",
        end: "",
        title: "",
        uid: "",
        tag: "",
        status: 5,
        chosen: 0,
        freeArea: 0,
        id: "",
        newsType: 0,
        liaoBaTop: undefined,
        isTop: undefined,
        isHappinessPlazaTop: undefined,
        isSortedUnderModule: undefined,
        isCommunity: undefined,
        isTiktok: undefined,
        reviewAccount: "wfy",
        sectionID: "",
        isPush: false,
      },
      exportLoading: false,
      isSelection: false,
      videoIds: [],
      dialogVisible: false,
      sections: [],
      subSections: [],
      isDisabled: false,
      isSubSection: true,
      subSectionList: [],
      subSectionId: "",
      searchSubSections: "",
      searchSubSectionId: "",
      isFeatured: false, // 是否为精选的窗口
      batchContent: "", // 批量操作的内容, featured-精选，''-专题
      isBatchDelete: false,
      deleteArr: [],
      isBatchDeleteLoading: false,
      // 批量修改是否推荐
      batchRecommend: "",
      isRecommendSta: false,
      isSetFree: false,
      setFreeArea: true,
    };
  },
  components: {
    MediaPopup,
    EditVideo,
    PreviewPicture,
    CommentAction,
    SetPopularity,
    VidHotQuery,
    BatchTagsPopup,
    DialogChangeTopic,
    DialogChangeTags,
    DialogSetRemoved,
    DialogSetPublishers,
    RichEditor
  },
  computed: {
    subTopicOptions() {
      const currentSection = this.sections.find(v => v.id === this.searchSubSections)
      if (currentSection) {
        return currentSection.allSection
      }
      return []
    }
  },
  watch: {
    isBatchEditing(val) {
      if (val) {
        this.isSetPublishers = this.batchContent === 'setPublisher'
        this.isSetRemoved = this.batchContent === 'setRemoved'
      } else {
        this.isSetPublishers = false
        this.isSetRemoved = false
      }
    }
  },
  created() {
    // this.queryStudioList();
    this.getVideoList();
  },
  methods: {
    editRichText(item) {
      this.$refs.editor.open(item)
    },
    changeStudio() {
      this.searchUid = "";
    },
    changeUid() {
      this.studioId = "";
    },
    sortVideo(row) {
      if (!this.params.sectionID) {
        this.$message.error("请先通过子标题筛选数据后，再进行操作！");
        return;
      }
      this.$prompt("请输入专题排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]\d*$/,
        inputErrorMessage: "请输入正整数",
      })
        .then(async ({ value }) => {
          let req = {
            videoID: row.id,
            sectionID: this.params.sectionID,
            sortCode: Number(value),
          };
          let ret = await API.editVideo(req);
          if (ret.code === 200) {
            this.$message({
              type: "success",
              message: "修改排序成功",
            });
            this.getVideoList();
          } else {
            this.$message({
              type: "error",
              message: "修改失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    async confirmBatechDel() {
      let videoIDs = this.videoIds.map((item) => item.id);
      let req = {
        sectionID: this.params.sectionID,
        videoIDs: videoIDs,
      };
      this.isBatchDeleteLoading = true;
      let ret = await API.batchDelete(req);
      this.isBatchDeleteLoading = false;
      if (ret.code === 200) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.giveUp();
        this.close();
        this.getVideoList();
      } else {
        this.$message.error("删除失败！");
      }
    },
    cancelBatechDel() {
      this.isBatchDelete = false;
    },
    // 批量删除
    async batchDelete() {
      if (!this.params.sectionID) {
        this.$message.error("请先通过子标题筛选数据后，再进行操作！");
        return;
      }
      this.batchContent = "delete";
      this.isSelection = true;
      this.isDisabled = true;
    },
    selectChild(val) {
      this.isSubSection = false;
      this.subSectionList = val;
      this.subSectionId = "";
    },
    searchSelectSection() {
      this.params.sectionID = "";
    },
    // 打开评论弹出框
    openComment(row) {
      const params = Object.assign(
        {},
        {
          objID: row.id,
          level: 1,
        }
      );
      this.$refs.commentAction.open(params);
    },
    // 获取工作室用户
    async queryStudioList() {
      let ret = await API.queryStudioList({ userType: 1 });
      // console.log(ret)
      if (ret && ret.code == 200) {
        this.studioList = ret.data;
        // console.log(this.studioList)
      }
    },
    // 获取视频列表
    getVideoList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.params.uid = this.searchUid || this.studioId;
      this.loading = true;
      this.getSections();
      API.getVideoList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data.vInfos) {
            this.tableData = res.data.vInfos;
            this.total = res.data.total;
            if (this.isDisabled) {
              this.restoreCheckedState();
            }
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 导出数据
    exportdata() {
      let req = JSON.parse(JSON.stringify(this.params));
      req.uid = req.uid ? Number(req.uid) : "";
      this.exportLoading = true;
      API.exportVideoList(req)
        .then((res) => {
          if (res && res.code == 200) {
            this.$message.success(
              "操作成功，请耐心等待数据导出到TG<数据导出对接群>"
            );
          }
          // if (res) {
          //   try {
          //     var blob = new Blob([res], {
          //       type:
          //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          //     }); // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
          //     var downloadElement = document.createElement("a");
          //     var href = window.URL.createObjectURL(blob); // 创建下载的链接
          //     downloadElement.href = href;
          //     downloadElement.download = "帖子列表.xlsx"; // 下载后文件名
          //     document.body.appendChild(downloadElement);
          //     downloadElement.click(); // 点击下载
          //     document.body.removeChild(downloadElement); // 下载完成移除元素
          //     window.URL.revokeObjectURL(href); // 释放掉blob对象
          //   } catch (error) {
          //     console.log(error);
          //     this.$message.error("导出失败！");
          //   }
          // }
        })
        .catch(() => {
          this.$message.error("导出失败！");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    getSections() {
      API.sectionList({}).then((res) => {
        if (res && res.code === 200) {
          this.sections = res.data;
        }
      });
    },
    // 下载原视频
    downloadMedia(row) {
      let sourceURL = new String(row.sourceURL);
      // eslint-disable-next-line no-useless-escape
      let index = sourceURL.lastIndexOf("/");
      let sourceUrl = sourceURL.substring(0, index + 1);
      let href = baseConfig.downLoadUrl + sourceUrl + row.fileName;
      window.open(href);
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getVideoList();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getVideoList();
    },
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.start = changeTime(time[0]) || "";
        this.params.end = changeTime(time[1]) || "";
      } else {
        this.params.start = "";
        this.params.end = "";
      }
      this.getVideoList("status");
    },
    // 编辑回调监听
    handlerVideoList() {
      this.getVideoList();
    },
    // 数据排序
    handleSortChange(column) {
      if (column.order) {
        this.params.value = sortEscape(column.order);
        this.params.key = column.prop;
      } else {
        this.params.value = "";
        this.params.key = "";
      }
      this.getVideoList();
    },
    // 推荐当前视频
    // addPush(row) {
    //   row.pushing = !row.pushing
    //   let text = row.pushing ? '您确定要取消推送当前视频吗？' : '您确定要推送当前视频吗？'
    //   this.$confirm( text, {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     if(row.pushing) {
    //       let params = {
    //         ids: [row.id],
    //       }
    //       API.cancelRecommend(params).then(res => {
    //         if (res.code === 200) {
    //           this.$message({
    //             message: '取消推送成功！',
    //             type: 'success'
    //           });
    //           this.getVideoList()
    //         } else {
    //           this.$message.error('取消推送失败！');
    //         }
    //       })
    //     } else {
    //       let params = {
    //         videoID: row.id,
    //         title: row.title,
    //       }
    //       API.setRecommend(params).then(res => {
    //         if (res.code === 200) {
    //           this.$message({
    //             message: '推送成功！',
    //             type: 'success'
    //           });
    //           this.getVideoList()
    //         } else {
    //           this.$message.error('推送失败！');
    //         }
    //       })
    //     }
    //   })
    // },
    // 图集预览
    previewPicture(pictureArr, id, tags) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id, tags);
    },
    handlerPreviewList() {
      this.getVideoList();
    },
    // 设为精选/免费
    setChosen(row, type) {
      switch (type) {
        case "chosen":
          this.videoHighlights(row);
          break;
        case "free":
          this.freeZone(row);
          break;
        case "isTopping":
          this.sticky(row);
          break;
        case "isRecommend":
          this.isRecommend(row);
          break;
        case "isChoosen":
          this.isChoosen(row);
          break;
        case "liaoBaTop":
          this.liaoBaTop(row);
          break;
        case "happinessPlazaTop":
          this.happinessPlazaTop(row);
          break;
      }
    },
    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type);
    },
    // 删除视频
    removeVideo(id) {
      this.$confirm("您确定要删除当当前视频吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.deleteVideos({ ids: [id] }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 删除推送视频
    quxiaoQtVideo(id) {
      this.$confirm("您确定要取消当前强推视频吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.cancelRecommend({ IDs: [id] }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("操作失败!");
          }
        });
      });
    },
    //强送forcePush
    forcePush(row) {
      this.$confirm("您确定要将当前视频强行推送吗？", "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.setRecommend({
          videoID: row.id,
          title: row.title,
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "强推成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("强推失败！");
          }
        });
      });
    },
    // 置顶视频
    placement(row) {
      if (row.status === 2) {
        this.$message.error("未通过视频不能置顶！");
        return false;
      }
      this.$confirm("您确定要将当前视频置顶吗？", "操作提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.setChosen({
          ids: [row.id],
          field: "topping",
          status: true,
        }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "置顶成功！",
              type: "success",
            });
          } else {
            this.$message.error("置顶失败！");
          }
        });
      });
    },
    // 编辑视频
    edit(row) {
      this.$refs.editVideo.open(row);
    },
    // 视频精选
    videoHighlights(row) {
      row.chosen = !row.chosen;
      let text = row.chosen
        ? "您确定要取消当前视频的精选推送吗？"
        : "您确定要推送当前视频至精选吗？";
      this.$confirm(text, "推送提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "chosen",
          status: !row.chosen,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "推送至精选成功！" : "取消精选成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("推送至精选失败！");
          }
        });
      });
    },
    // 是否免费
    freeZone(row) {
      row.freeArea = !row.freeArea;
      let text = row.freeArea
        ? "您确定要取消设置为免费专区吗？"
        : "您确定要设置为免费专区吗？";
      this.$confirm(text, "免费设置提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "freeArea",
          status: !row.freeArea,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "设置免费专区成功！" : "取消免费专区！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("设置免费专区失败！");
          }
        });
      });
    },
    // 是否置顶
    sticky(row) {
      row.isTopping = !row.isTopping;
      let text = row.isTopping ? "您确定要取消置顶吗？" : "您确定要置顶吗？";
      this.$confirm(text, "置顶提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "isTopping",
          status: !row.isTopping,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "置顶成功！" : "取消置顶！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("置顶失败！");
          }
        });
      });
    },
    // 是否力荐
    isRecommend(row) {
      row.isRecommend = !row.isRecommend;
      let text = row.isRecommend
        ? "您确定要取消力荐该帖子吗？"
        : "您确定要力荐改帖子吗？";
      this.$confirm(text, "力荐提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "isRecommend",
          status: !row.isRecommend,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "设置力荐成功！" : "取消力荐成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("设置力荐失败");
          }
        });
      });
    },
    // 是否置精
    isChoosen(row) {
      row.isChoosen = !row.isChoosen;
      let text = row.isChoosen ? "您确定要取消置精吗？" : "您确定要置精吗？";
      this.$confirm(text, "置精提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "isChoosen",
          status: !row.isChoosen,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "置精成功！" : "取消置精！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("置精失败");
          }
        });
      });
    },
    // 是否撩吧置顶
    liaoBaTop(row) {
      row.liaoBaTop = !row.liaoBaTop;
      let text = row.liaoBaTop
        ? "您确定要取消撩吧置顶吗？"
        : "您确定要撩吧置顶吗？";
      this.$confirm(text, "撩吧置顶提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: [row.id],
          field: "liaoBaTop",
          status: !row.liaoBaTop,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status ? "撩吧置顶成功！" : "取消撩吧置顶成功！",
              type: "success",
            });
            this.getVideoList();
          } else {
            this.$message.error("撩吧置顶失败！");
          }
        });
      });
    },
    // // 是否幸福广场置顶
    // happinessPlazaTop(row) {
    //   row.happinessPlazaTop = !row.happinessPlazaTop;
    //   let text = row.happinessPlazaTop
    //     ? "您确定要取消幸福广场置顶吗？"
    //     : "您确定要幸福广场置顶吗？";
    //   this.$confirm(text, "幸福广场置顶提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   }).then(() => {
    //     let params = {
    //       ids: [row.id],
    //       field: "happinessPlazaTop",
    //       status: !row.happinessPlazaTop,
    //     };
    //     API.setChosen(params).then((res) => {
    //       if (res.code === 200) {
    //         this.$message({
    //           message: params.status ? "幸福广场置顶成功！" : "取消幸福广场置顶成功！",
    //           type: "success",
    //         });
    //         this.getVideoList();
    //       } else {
    //         this.$message.error("幸福广场置顶失败！");
    //       }
    //     });
    //   });
    // },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      /**
       * 1.取消勾选时，将添加的数据从this.videoIds这个数据表里去除;
       * ① 获取到当前数据列表中未勾选的数据；
       * ② 从this.videoIds这个数据表中移除未勾选的数据；
       */
      // ①获取到当前数据列表中未勾选的数据；
      let tempTableData = JSON.parse(JSON.stringify(this.tableData));
      objArr.forEach((item) => {
        this.tableData.forEach((value, index) => {
          if (item === value) {
            tempTableData.splice(index, 1);
          }
        });
      });
      // ②从this.videoIds这个数据表中移除未勾选的数据；
      tempTableData.forEach((item) => {
        this.videoIds.forEach((value, index) => {
          if (item.id === value.id) {
            this.videoIds.splice(index, 1);
          }
        });
      });
      // 2.添加数组数据，需要去重
      this.videoIds = this.videoIds.concat(objArr);
      const tempVideos = new Set(this.videoIds);
      this.videoIds = Array.from(tempVideos);
    },
    // 翻页时的勾选回显
    restoreCheckedState() {
      /**
       * ①获取到当前数据表格中已经被选中的数据
       */
      const indexs = this.tableData
        .map((item) => {
          let flag = false;
          this.videoIds.forEach((value) => {
            value.id === item.id ? (flag = true) : "";
          });
          if (flag) {
            return item;
          }
        })
        .filter((item) => item);
      /**
       * ②回显当前数据表格中已经被勾选过的数据
       */
      this.$nextTick(() => {
        indexs.forEach((rows) => {
          this.$refs.multipleTable.toggleRowSelection(rows);
        });
      });
    },
    openSelection(param) {
      // if (param === "featured") {
      //   this.batchContent = "featured";
      // }
      this.batchContent = param ? param : "featured";
      this.isSelection = true;
      this.isDisabled = true;
    },
    async setRemoved(params) {
      try {
        await this.$confirm("您确定要下架这些帖子吗？", "下架提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        let ids = this.videoIds.map((item) => item.id);
        const r = await API.offShelfVideos({
          ids
        })
        this.getVideoList();
        this.giveUp()
        this.$message.success('批量设置成功')
      } catch (error) {

      }
    },
    async batchSetPublushers(params) {
      try {
        let ids = this.videoIds.map((item) => item.id);
        const r = await API.setPublisher({
          ids, ...params
        })
        this.getVideoList();
        this.giveUp()
        this.$message.success('批量设置发布者成功')
      } catch (error) {

      }
    },
    // 配置视频热度统计计算方式
    openSetPopularity() {
      this.$refs.setPopularity.open();
    },
    // 打开热度查询
    openHotQuery() {
      this.$refs.hotQuery.open();
    },
    subSection() {
      if (this.videoIds.length == 0) {
        this.$message.error("请至少选择一条数据");
        return;
      }
      // this.isBatchEditing = true;
      if (this.batchContent === "featured") {
        this.isFeatured = true;
      } else if (this.batchContent === "delete") {
        this.isBatchDelete = true;
      } else if (this.batchContent === "recommend") {
        this.isRecommendSta = true;
      } else if (this.batchContent === "setFree") {
        this.isSetFree = true;
      } else if (this.batchContent === "batchEditTag") {
        let checkedData1 = JSON.parse(JSON.stringify(this.videoIds));
        const videoIds = checkedData1.map((item) => item.id);
        this.$refs.batchTagsPopup.open(videoIds);
      } else if (typeof this[this.batchContent] === 'function') {
        this[this.batchContent].call(this)
      } else if (this.batchContent === 'setTopic') {
        this.dialogVisible = true;
      } else if (this.batchContent === 'setPublisher') {
        this.isSetPublishers = true
      } else if (!this.batchContent) {
        this.dialogVisible = true;
      }
    },
    uploadSection(sectionId) {
      let videoIDs = this.videoIds.map((item) => item.id);
      if (this.batchContent === "featured") {
        let params = {
          ids: videoIDs,
          field: "chosen",
          status: this.featured,
        };
        API.setChosen(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: params.status
                ? "批量设置为精选成功！"
                : "批量取消撩精选成功！",
              type: "success",
            });
            this.giveUp();
            this.close();
            this.getVideoList();
          } else {
            this.$message.error("批量修改是否精选失败");
          }
        });
      } else {
        videoIDs = videoIDs.toString();
        let req = {
          sectionID: sectionId || '',
          videoIDs: videoIDs,
        };
        API.batch(req)
          .then((res) => {
            if (res && res.code === 200) {
              this.$message.success("上传成功");
            } else {
              this.$message.error("上传失败");
            }
            this.giveUp();
            this.close();
            this.getVideoList();
          })
          .catch((err) => {
            this.$message.err("上传失败" + err);
          });
      }
    },
    async batchPermission(params) {
      try {
        let ids = this.videoIds.map((item) => item.id);

        const r = await API.setTagPermission({
          ids, ...params
        })
        this.getVideoList();
        this.giveUp();
        this.isSetFree = false
        this.$message.success('批量设置标签/观看权限成功')
      } catch (error) {
        console.error(error);
      }
    },
    batchSetRecommend() {
      let ids = this.videoIds.map((item) => item.id);
      let req = {
        ids: ids,
        reco: this.batchRecommend,
      };
      API.batchSetRecommend(req)
        .then((res) => {
          if (res && res.code == 200) {
            this.isRecommendSta = false;
            this.$message.success("设置成功");
            this.giveUp();
            this.getVideoList();
          }
        })
        .catch((err) => {
          this.$message.error("设置失败" + err);
        });
    },
    batchSetFree() {
      let ids = this.videoIds.map((item) => item.id);
      let req = {
        ids: ids,
        field: "freeArea",
        status: this.setFreeArea,
      };
      API.setChosen(req).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: req.status ? "设置免费专区成功！" : "取消免费专区！",
            type: "success",
          });
          this.isSetFree = false;
          this.giveUp();
          this.getVideoList();
        } else {
          this.$message.error("设置免费专区失败！");
        }
      });
    },
    handlerClose() {
      this.getVideoList();
      this.giveUp();
    },
    giveUp() {
      this.batchContent = "";
      this.isDisabled = false;
      this.isSelection = false;
      this.subSections = "";
      this.subSectionId = "";
      this.featured = true;
      this.videoIds = [];
      this.isBatchEditing = false
      this.isRecommendSta = false
      this.isSetPublishers = false
      this.$refs.multipleTable.clearSelection();
    },
    // 关闭窗口
    close() {
      this.isFeatured = false;
      this.dialogVisible = false;
      this.isBatchDelete = false;
      this.isBatchEditing = false
    },
    closeRecommend() {
      this.batchRecommend = "";
    },
    closeIsSetFree() {
      this.setFreeArea = true;
    },
  },
  filters: {
    getVideoPermissionName(val) {
      return getTypeLabel(val, videoPermissionTypes)
    }
  }
};
</script>
<style scoped lang="scss">
.picturePreview {
  max-width: 300px;
  display: flex;
}

.videoList-box {
  min-height: 100vh;
  overflow-y: auto;
}

.bottom {
  margin-top: 20px;

  .btn {
    display: inline-block;
    margin-left: 20px;
  }

  .page {
    display: inline-block;
    float: right;
  }
}

.el-pagination {
  margin-top: 0 !important;
}

.dialog-footer {
  left: 0;
}

.tagBox {
  display: inline-block;
  margin-right: 5px;
}
</style>
